import { Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import FindProductInput from 'components/findProduct/FindProductInput'
import ProductsList from 'components/findProduct/ProductsList'
import { useEffect, useState } from 'react'
import z from 'zod'

const validateSearch = z.object({
  page: z.number().default(1),
  pageSize: z.number().default(8),
  searchText: z.string().default(''),
})

export const Route = createFileRoute('/_auth/')({
  component: HomeComponent,
  validateSearch,
})

function HomeComponent() {
  const { searchText } = Route.useSearch()
  const [search, setSearch] = useState(searchText)

  useEffect(() => {
    if (searchText !== search) {
      setSearch(searchText)
    }
  }, [searchText])

  return (
    <div>
      <Title order={1} mb="md">
        Znajdź produkt
      </Title>
      <FindProductInput value={search} onChange={({ target }) => setSearch(target.value)} />
      <ProductsList searchSymbol={search} />
    </div>
  )
}
